import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import {
  AnalysesTypesLowercase,
  BloodPanel,
} from 'src/app/analyses/interfaces/analyses.types';

@Component({
  selector: 'app-analyses-groups',
  templateUrl: './analyses-groups.component.html',
  styleUrls: ['./analyses-groups.component.scss'],
})
export class AnalysesGroupsComponent {
  @Input() set groups$(bloodGroups$: Observable<BloodPanel[]>) {
    this.bloodGroups$ = bloodGroups$.pipe(
      tap((groups) => {
        this.isLoading = false;
        this.groupsLoaded.emit(groups);
      })
    );
  }
  @Input() panels;

  @Output() groupsLoaded = new EventEmitter<BloodPanel[]>();

  public bloodGroups$: Observable<BloodPanel[]>;
  public isLoading = true;
  public readonly AnalysesTypesLowercase = AnalysesTypesLowercase;
}
